import { isEmpty, escapeRegExp } from 'lodash'
import { RichMentionedUrl } from 'schemas/RichMentionedUrlSchema'

export const replaceMentionedUrls = (text: string, mentionedUrls: RichMentionedUrl[]) => {
  if (isEmpty(mentionedUrls)) {
    return text
  }

  let resultText = text
  mentionedUrls.forEach((mentionedUrl) => {
    resultText = resultText.replace(
      new RegExp(escapeRegExp(mentionedUrl.url!), 'g'),
      mentionedUrl.displayUrl!
    )
  })

  return resultText
}

export default replaceMentionedUrls
